import { gql } from '@apollo/client';

import { Course } from '../../types';
import { CourseFormInput } from '../../types/form';
import { courseFragment } from '../fragments';

export interface UpdateCourseMutationVariables {
  courseId: string;
  input: CourseFormInput;
}

export interface UpdateCourseMutationResult {
  course: Course;
}

export const updateCourseMutation = gql`
  mutation UpdateCourse($courseId: String!, $input: UpdateCourseInput!) {
    course(courseId: $courseId, input: $input) @rest(type: "Course", path: "courses/{args.courseId}", method: "PUT") {
      ...Course
    }
  }
  ${courseFragment}
`;
